import { useReducer } from "react";
import CartContext from "./cart-context";

const defaultCartState = {
  items: [],
  totalAmount: 0,
};

// state bevat items en totalAmount
// action bevat type en item (waarbij item een object is met id, name, amount, price)
const cartReducer = (state, action) => {
  if (action.type === "ADD") {
    console.log("cartReducer, ADD");
    console.log("state.totalAmount: " + state.totalAmount);
    console.log("action.item.aankoopprijs: " + action.item.aankoopprijs);
    console.log(
      "action.item.aankoophoeveelheid: " + action.item.aankoophoeveelheid
    );

    const updatedTotalAmount =
      state.totalAmount +
      action.item.aankoopprijs * action.item.aankoophoeveelheid;
    console.log("updatedTotalAmount: " + updatedTotalAmount);

    // Zoek of de index van wat je wil toevoegen reeds aanwezig is in de Cart
    const existingCartItemIndex = state.items.findIndex(
      (item) => item.id === action.item.id
    );

    // Prik met de gevonden index in de array en existingCartItem wordt
    // gevuld met het gevonden item. Indien index niet gevonden, dan is
    // existingCartItem null.
    const existingCartItem = state.items[existingCartItemIndex];

    let updatedItems;

    if (existingCartItem) {
      const updatedItem = {
        ...existingCartItem,
        aankoophoeveelheid:
          existingCartItem.aankoophoeveelheid + action.item.aankoophoeveelheid,
      };
      updatedItems = [...state.items];
      updatedItems[existingCartItemIndex] = updatedItem;
    } else {
      updatedItems = state.items.concat(action.item);
    }

    return {
      items: updatedItems,
      totalAmount: updatedTotalAmount,
    };
  }

  if (action.type === "REMOVE") {
    const existingCartItemIndex = state.items.findIndex(
      (item) => item.id === action.id
    );
    const existingItem = state.items[existingCartItemIndex];
    const updatedTotalAmount = state.totalAmount - existingItem.aankoopprijs;
    let updatedItems;
    if (existingItem.aankoophoeveelheid === 1) {
      updatedItems = state.items.filter((item) => item.id !== action.id);
    } else {
      const updatedItem = {
        ...existingItem,
        aankoophoeveelheid: existingItem.aankoophoeveelheid - 1,
      };
      updatedItems = [...state.items];
      updatedItems[existingCartItemIndex] = updatedItem;
    }

    return {
      items: updatedItems,
      totalAmount: updatedTotalAmount,
    };
  }

  if (action.type === "CLEAR") {
    return defaultCartState;
  }

  return defaultCartState;
};

// CartProvider wordt in App om alles heen gezet
const CartProvider = (props) => {
  const [cartState, dispatchCartAction] = useReducer(
    cartReducer,
    defaultCartState
  );

  // Je geeft item door aan reducer functie dispatchCartAction
  const addItemToCartHandler = (item) => {
    console.log("addItemToCartHandler");
    console.log(item);
    dispatchCartAction({ type: "ADD", item: item });
  };

  const removeItemFromCartHandler = (id) => {
    console.log("removeItemFromCartHandler");
    console.log(id);
    dispatchCartAction({ type: "REMOVE", id: id });
  };

  const clearCartHandler = () => {
    dispatchCartAction({ type: "CLEAR" });
  };

  const cartContext = {
    items: cartState.items,
    totalAmount: cartState.totalAmount,
    addItem: addItemToCartHandler,
    removeItem: removeItemFromCartHandler,
    clearCart: clearCartHandler,
  };

  return (
    <CartContext.Provider value={cartContext}>
      {props.children}
    </CartContext.Provider>
  );
};

export default CartProvider;
